import { Auth } from '@nackle/bridge';
import { idURL } from 'endpoints';

const auth = new Auth( {
    authority: idURL
} );

export default auth;

export function authRequestMiddleware ( url, options = {} ) {
    if ( !auth || !auth.state || !auth.state.access_token ) {
        return;
    }

    options.headers = {
        ...( options.headers || {} ),
        'authorization': `Bearer ${ auth.state.access_token }`
    };
}

export function authRouteMiddleware( action, nextRoute, prevRoute ) {
    // we aren't signed in yet, so continue
    if ( !auth.state.access_token ) {
        return action.ok();
    }

    const nextCompanyId = nextRoute?.state?.params?.companyId;
    // if the next companyId is the same as the last companyId, continue
    if ( nextCompanyId === auth.state.company_id ) {
        return action.ok();
    }

    // switch to the new company
    auth.delegate( nextCompanyId ).then( () => {
        action.ok();
    } ).catch( error => {
        console.error( error );
    } );
}


export function hasPermission( permission ) {
    const [ app, key ] = permission.split( '.', 2 );

    const userPermissions = auth?.state?.claims?.permissions;
    if ( !userPermissions ) {
        return false;
    }
    const appPermissions = userPermissions[ app ];
    if ( !Array.isArray( appPermissions ) ) {
        return false;
    }
    return appPermissions.includes( key );
}

export const permissions = {
    GIFT_CODE_SEARCH: 'gift-code.search-gift-code',
    GIFT_CODE_ISSUE: 'gift-code.issue-gift-code',
    GIFT_CODE_EXPIRE: 'gift-code.expire-gift-code',
    GIFT_CODE_CANCEL: 'gift-code.cancel-gift-code',
    GIFT_CODE_RETURN: 'gift-code.return-gift-code',
    GIFT_CODE_CONVERT: 'gift-code.convert-gift-code'
};